/**
 *热点聚焦
 *2017-11-19
 *Bai.Zhiming 
 */
"use strict";
angular.module("hotFocusModule", [
	"hotFocusServiceModule", //热点头条工厂
	"hotFocusRouter", //热点聚焦路由
	"hotFocusLeftModule", //热点聚焦左侧
	"regionalHotSoptsModule", //地域热点模块
	"fieldHotSpotsModule", //领域热点模块
	"PlanHotHeadLineRouterModule",//领域热点详情页路由
	"timeHotSpotsModule", // 时段热点模块
	"channelHotSpotsModule", //渠道热点模块

]).
controller("hotFocusCtrl", function() {

});